export { InvoiceDetailsContent } from './InvoiceDetailsContent';
